import { useContext, useState } from 'react';
import '../../style/components/loginForm.css';
import { config } from '../../context/config';
import { action } from '../../context/action';
import { auth } from '../../context/auth';
import { validationLoginStaff } from '../../funcs/validation/validationLoginStaff';
import { isOnline } from '../../funcs/isOnline';
import { ServerRunning } from '../../funcs/serverRunning';
import { useTranslation } from 'react-i18next';
import { switchh } from '../../context/switch';
import iconShow from '../../docs/light/eye.png';
import iconHide from '../../docs/light/hidden.png';

export default function LoginForm(props) {
    const { api, devKey } = useContext(config);
    const { t } = useTranslation()
    const { errorMessage, setErrorMessage } = useContext(action);
    const { setLoadingProcess, loadingProcess } = useContext(switchh);
    const { user } = useContext(auth);
    
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const handleSubmit = async (e)=> {
        e.preventDefault();
        setLoadingProcess(true);
        if(!username || !password) {
            setErrorMessage(t("error:login.empty"));
            setLoadingProcess(false);
            return;
        }
        try {
            if(props.mode === "login") {
                // code login
                if(!devKey || devKey.length !== 16) {
                    setErrorMessage("ادخل الرقم مفتاح الجهاز بشكل صحيح");
                    return;
                }
                try {
                    const response = await fetch(`${api}/user/login`, {
                        method: "POST",
                        headers: {
                            "Content-Type":"application/json",
                            Authorization: `Bearer ${devKey}`
                        },
                        body: JSON.stringify({
                            username: username,
                            password: password,
                        }),
                        credentials: "include"
                    })
                    const res = await response.json();
                    
                    if(res.status) {
                        window.location.reload();
                        return;
                    }
                    else setErrorMessage(res.message);
                }
                catch(error) {
                    setErrorMessage(t("error:internalServerError"));
                }
            }
            else if(props.mode === "authorization")
            {
                // code authorization -> localhost
            }
            else {    
                
                const result = await validationLoginStaff(username, password);

                if (!result.status && result.message.head === "undefined-employee") {
    
                    if (!isOnline()) {
                        setErrorMessage(t("error:loginEmp.notOnline"));
                        return;
                    }
                    
                    const serverAlive = await ServerRunning();
                    if (!serverAlive) {
                        setErrorMessage(t("error:loginEmp.serverProblem"));
                        return;
                    }
    
                    try {
                        const response = await fetch(`${api}/employee/login`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            credentials: "include",
                            body: JSON.stringify({
                                username,
                                password,
                                auth: user.data[0].userID
                            })
                        });
    
                        if (!response.ok) {
                            setErrorMessage(t("error:login.wrong"));
                            return;
                        }
    
                        setErrorMessage("");
                        window.location.reload();
    
                    } catch (err) {
                        console.error(err);
                        setErrorMessage(t("erro:loginEmp.unexpectedError"));
                    }
    
                    return;
                }
    
                if (!result.status) {
                    setErrorMessage(result.message.body);
                    return;
                }
    
                window.location.reload();
            }
        }
        catch(err) {
            setErrorMessage(t("error:internalServerError"));
        }
        finally {
            setLoadingProcess(false);
        }
    }

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(prevState => !prevState);
    }

    return (
        <form onSubmit={handleSubmit} className='form-login'>
            <input value={username} onChange={(e) => setUsername(e.target.value)} type="text" placeholder={t("auth:user")} />
            <div className="password-field">
                <input value={password} onChange={(e) => setPassword(e.target.value)} type={showPassword ? "text" : "password"} placeholder={t("auth:pass")} />
                <button type="button" onClick={togglePasswordVisibility}>
                    <img src={showPassword ? iconHide : iconShow} alt={"toggle password visibility"} />
                </button>
            </div>
            <p className='error text-weight-bold'>{errorMessage ? <span> {errorMessage}</span> : ""}</p>
            {/* put enable button for forgot password because i will use it in login only  */}
            { props.enableForgetPass && <a href="/">{t("auth:forgotPass")}</a> }
            <button className='submit-btn' disabled={loadingProcess} type="submit">
                {loadingProcess ? t("common:loading") : t("auth:login")}
            </button>
        </form>
    )
}